import angular from 'angular';
export class ModalsService {
    constructor($translate, $rootScope, globalUi) {
        this.$translate = $translate;
        this.$rootScope = $rootScope;
        this.globalUi = globalUi;
        this.scope = {};
        this.multipleModalsOpened = false; // extension + in-call settings could be opened at same time
    }
    open(type, scope) {
        if (this.globalUi.ui.modalOpen) {
            this.multipleModalsOpened = true;
        }
        if (scope?.multipleAllowed) {
            // do not count modals on some cases (i.e. payment waiting.)
            this.multipleModalsOpened = false;
        }
        this.currentModal = type;
        this.scope = scope;
        this.$rootScope.$broadcast('modal.show');
    }
    close() {
        this.currentModal = null;
        this.scope = {};
        if (this.multipleModalsOpened) {
            // prevent broadcasting if we are not closing ALL modals
            this.multipleModalsOpened = false;
            return;
        }
        this.$rootScope.$broadcast('modal.hide');
    }
}
export default angular
    .module('doxy.common.components.modals.modalsService', [])
    .service('modalsService', ModalsService).name;
